<mat-accordion [displayMode]="'flat'"
               [togglePosition]="'before'"
>
    @for (group of allGroups; track group.id) {
        <mat-expansion-panel class="accordion-item">
            <mat-expansion-panel-header
                    [collapsedHeight]="'48px'"
                    [expandedHeight]="'48px'"
            >
                <mat-panel-title>
                    {{ group.title }}
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container *ngTemplateOutlet="boardsTemplate, context:{'boards' : group.boards}"></ng-container>
        </mat-expansion-panel>
    }

    <mat-expansion-panel class="accordion-item">
        <mat-expansion-panel-header
                [collapsedHeight]="'48px'"
                [expandedHeight]="'48px'"
        >
            <mat-panel-title>
                {{ 'INDEX_PAGE.BUSINESS_PROCESS.TEXT.BP_LIST' | translate }}
            </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-container *ngTemplateOutlet="boardsTemplate, context:{boards: boards}"></ng-container>

    </mat-expansion-panel>
</mat-accordion>

<ng-template let-boards="boards"
             #boardsTemplate
>
    <div class="boards-container">
        @for (board of boards; track board.alias) {
            <div class="board-item"
                 (click)="goTo($event, board, 'table')"
            >
                <div class="board-header">
                    <i class="board-icon"
                       [class]="board.icon"
                    ></i>
                    <span>{{ board.alias }}</span>

                    <span class="action-icon">
                        <i class="ri-settings-3-line"
                           (click)="goTo($event, board, 'settings')"
                        ></i>
<!--                    <i class="ri-delete-bin-5-line"></i>-->
                    </span>
                </div>
                <div class="board-content">
                    <span class="name"
                          [matTooltip]="board.name"
                    >
                        {{ board.name }}
                    </span>

                    <div class="description"
                         [matTooltip]="board.description"
                         [innerHTML]="board.description"
                    ></div>
                </div>
            </div>
        } @empty {
            <div>{{ 'EMPTY_LISTS.BOARDS' | translate }}</div>
        }
    </div>
</ng-template>


<!--<ng-template #settingsView let-modal>-->
<!--    <app-button-modal-close [modal]="modal"></app-button-modal-close>-->
<!--    <div class="modal-body">-->
<!--        <app-board-settings-modal-->
<!--                (emitReloading)="emitReloading.emit($event)"-->
<!--                [board]="selectedBoard"-->
<!--        ></app-board-settings-modal>-->
<!--    </div>-->
<!--</ng-template>-->
